import consumer from "./consumer"

consumer.subscriptions.create("MessageChannel", {
  connected() {
    console.log("MessageChannel connected")
  },

  disconnected() { },

  received(data) {
    console.log("MessageChannel received", data)

    const chatId = data.chat_id
    const history = document.querySelector(
      `.ravi-room__chat-history[data-channel='chat-${chatId}']`
    )

    if (!history) {
      console.log("History element not found for chat_id:", chatId)
      return
    }

    if (data.message && data.message.thread_messages) {
      history.dataset.threadMessages = data.message.thread_messages
    }

    const loader = history.querySelector("#assistant-loader")
    if (loader) loader.remove()

    if (!data.message || !data.message.answer) {
      console.log("Message has no answer yet")
      return
    }

    const bubble = this.buildAssistantBubble({
      answer: data.message.answer,
      timestamp: data.message.updated_at || data.message.created_at,
    })

    history.appendChild(bubble)
    history.scrollTop = history.scrollHeight
  },

  buildAssistantBubble({ answer, timestamp }) {
    const bubble = document.createElement("article")
    bubble.className = "chat-bubble flex flex-col gap-3 max-w-[75%] mr-auto p-4 rounded-2xl bg-gradient-to-br from-slate-800/90 to-slate-900/90 border border-purple-500/30 shadow-xl shadow-purple-900/30 animate-slide-up hover:shadow-purple-900/40 hover:border-purple-500/40 transition-all duration-200"

    const author = document.createElement("div")
    author.className = "chat-bubble__author flex items-center gap-3"
    author.innerHTML = `
      <div class="relative">
        <img src="/assets/images/ravi/rav.jpeg" alt="Rav" class="w-10 h-10 rounded-xl object-cover shadow-lg ring-2 ring-purple-500/30">
        <div class="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-slate-800 flex items-center justify-center">
          <i class="fa-solid fa-check text-[8px] text-white"></i>
        </div>
      </div>
      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <strong class="text-white font-semibold text-sm">Rav IA</strong>
          <span class="px-2 py-0.5 bg-gradient-to-r from-purple-600/30 to-purple-800/30 border border-purple-500/30 rounded-full text-[10px] text-purple-200 font-medium flex items-center gap-1">
            <i class="fa-solid fa-sparkles text-[8px]"></i>
            IA
          </span>
        </div>
        <span class="text-slate-400 text-xs">${this.formatTimestamp(timestamp)}</span>
      </div>
    `

    const content = document.createElement("div")
    content.className = "chat-bubble__content text-slate-200 text-sm leading-relaxed"
    content.appendChild(this.formattedText(answer))

    bubble.appendChild(author)
    bubble.appendChild(content)

    return bubble
  },

  formattedText(text) {
    const container = document.createElement("div")

    const paragraphs = (text || "").split("\n\n")

    paragraphs.forEach((paragraph, paragraphIndex) => {
      const lines = paragraph.split("\n")

      lines.forEach((line, lineIndex) => {
        const lineDiv = document.createElement("div")

        line
          .split(/(\*\*[^*]+\*\*)/)
          .filter(Boolean)
          .forEach((segment) => {
            if (segment.startsWith("**") && segment.endsWith("**")) {
              const bold = document.createElement("b")
              bold.textContent = segment.slice(2, -2)
              lineDiv.appendChild(bold)
            } else {
              const span = document.createElement("span")
              span.textContent = segment
              lineDiv.appendChild(span)
            }
          })

        container.appendChild(lineDiv)
      })

      if (paragraphIndex < paragraphs.length - 1) {
        container.appendChild(document.createElement("br"))
      }
    })

    return container
  },

  formatTimestamp(value) {
    if (!value) return "agora"

    const date = value instanceof Date ? value : new Date(value)
    const day = date.getDate()
    const monthFormatter = new Intl.DateTimeFormat("pt-BR", {
      month: "long"
    })
    const month = monthFormatter.format(date)
    const monthCapitalized = month.charAt(0).toUpperCase() + month.slice(1)

    const timeFormatter = new Intl.DateTimeFormat("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    })
    const time = timeFormatter.format(date)

    return `${day} de ${monthCapitalized}, ${time}`
  },
})